// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_6y-0";